import Nav from "../Nav";
import Head from "../Head";

const Bios = () => {
  window.scrollTo(0, 0);

  return (
    <>
      <Head title="Nosotras -  Biografías" />
      <Nav titulo="Biografías" link="/nosotras" />
      <section
        id="about_me"
        className="animate__fadeInDown wow animate__animated animate__delay-0s animate__slower"
      >
        <div className="container-fluid overflow-hidden">
          <div className="row marMob">
            <div className="col-12 col-lg-7 text-md-start col-xl-9">
              <h3>Lau Basilico</h3>
              <hr />
            </div>
            <div className="mb-3 col-12 col-lg-5 col-xl-3 text-center">
              <a
                target="_blank"
                href="https://www.instagram.com/lau.basilico/"
                rel="noopener noreferrer"
              >
                <img
                  src="../img/lau_reveadoconrosamosqueta.jpg"
                  className="img-fluid imgBio"
                  alt="Foto de Lau Basilico"
                />
              </a>
            </div>
            <p>
              María Laura Basilico (Arrecifes, Buenos Aires, 1985) es fotógrafa,
              museóloga y artista visual. <br />
              <br />
              Su formación de grado es en Antropología (UNR) algo que se
              manifiesta en sus intereses artísticos. Participó en las
              residencias Curadora, Wabi Sabi y Mudar.
              <br />
              <br />
              Trabaja como docente de fotografía en distintas instituciones
              culturales de la ciudad de Rosario. También ha participado de
              circuitos de ferias regionales y dictando talleres en espacios
              públicos de la región.
              <br />
              <br />
              Desde 2015 coordina el proyecto “Espacio Analógico” laboratorio de
              prácticas analógicas y experimentales en las ciudades de Rosario,
              Santa Fe y Paraná.
              <br />
              <br />
              Actualmente lleva adelante el proyecto Revelar con plantas (becado
              en 2022 por Plan Fomento de la Provincia de Santa Fe y el FNA)
              <br />
              <br />
              <a
                href="https://www.espacioanalogico.com.ar/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <span className="violeta">www.espacioanalogico.com.ar</span>
              </a>
            </p>
            <p className="violeta">
              <a
                href="https://www.instagram.com/lau.basilico/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="violeta bi bi-instagram"> </i>
                <span className="violeta">@lau.basilico</span>
              </a>
            </p>
          </div>
          <hr className="d-lg-none" />
          <div className="row marMob mb-5 mt-3">
            <div className="mb-3 col-12 col-lg-5 col-xl-3 text-center">
              <a
                target="_blank"
                href="https://www.pazsecundini.com.ar/"
                rel="noopener noreferrer"
              >
                <img
                  src="../img/paz_reveladoconrosamosqueta.jpg"
                  className="img-fluid imgBio"
                  alt="Foto de Paz secundini"
                />
              </a>
            </div>
            <div className="col-12 col-lg-7 text-md-end col-xl-9">
              <h3>Paz Secundini</h3>
              <hr />
            </div>
            <p className="text-md-end">
              Paz Secundini (Villa Libertador San Martín, Entre Ríos, 1988) es
              Licenciada en Bellas Artes (UNR) y se especializó en Estudios
              Irlandeses (USAL). <br />
              <br />
              Su obra fue seleccionada en el 60° Salón Provincial de Entre Ríos
              y en el 5° Premio Fundación OSDE (2023).
              <br />
              <br />
              Se presentó en Otra Feria episodio Jóvenes Artistas Americanos
              (2020) y ArteCo (2021/2022) en la que formó parte del
              conversatorio "La obra de arte y la artesanía, tradición y
              contemporaneidad". <br />
              <br />
              Participó en las residencias Campamento cerámico (2019), Córdoba,
              SirveVerse (2022), Córdoba, Mudar (2022), Cabo Polonio y Río
              (2024, Beca artista regional), Entre Ríos. <br />
              <br />
              Cursó Talleres de Formación Socio Ambiental (2019. Re
              Sapiens/Secretaría de Extensión UNR) e hizo un voluntariado en el
              PN Lago Puelo, Chubut (2023). <br />
              <br />
              Actualmente lleva adelante el proyecto Revelar con plantas (becado
              en 2022 por Plan Fomento de la Provincia de Santa Fe y el FNA), da
              clases de cerámica en su taller y es adscripta a la cátedra de
              Pintura III (FHyA-UNR).
              <br />
              <br />
              <a
                href="https://www.pazsecundini.com.ar/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <span className="violeta">www.pazsecundini.com.ar</span>
              </a>
            </p>
            <p className="text-md-end">
              <a
                href="https://www.instagram.com/jardin.de.invierno/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="violeta bi bi-instagram"> </i>
                <span className="violeta">@jardin.de.invierno</span>
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Bios;
